/**
 * @generated SignedSource<<4903fa95a2ff1cb3c96f4a036af73d50>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsYourFirmRep_viewer$data = {
  readonly user: {
    readonly tradeFirm: {
      readonly " $fragmentSpreads": FragmentRefs<"useTradeBenefitsContact_tradeFirm">;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useTradeBenefitsContact_viewer">;
  readonly " $fragmentType": "TradeBenefitsYourFirmRep_viewer";
};
export type TradeBenefitsYourFirmRep_viewer$key = {
  readonly " $data"?: TradeBenefitsYourFirmRep_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsYourFirmRep_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsYourFirmRep_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTradeBenefitsContact_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useTradeBenefitsContact_tradeFirm"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3486a3316cfa3767efc4b1c842d1c8c6";

export default node;
